import cx from 'classnames'
import PropTypes from 'prop-types'

import {GAP_SIZES} from './settings.js'

const ListMobileScrollContainer = ({children, gapSize = GAP_SIZES.m}) => {
  const listClassName = cx('mt-ListMobileScroll', `mt-ListMobileScroll--gap--${gapSize}`)
  return <ul className={listClassName}>{children}</ul>
}

ListMobileScrollContainer.displayName = 'ListMobileScrollContainer'
ListMobileScrollContainer.propTypes = {
  gapSize: PropTypes.oneOf(Object.values(GAP_SIZES)),
  children: PropTypes.node.isRequired
}

export default ListMobileScrollContainer
